import React, { useState } from 'react';
import type { ChangeVote } from '../types';

interface VoterListProps {
  votes: ChangeVote[] | undefined;
}

const VoterList: React.FC<VoterListProps> = ({ votes }) => {
  const [showAll, setShowAll] = useState(false);

  if (!votes || votes.length === 0) {
    return null;
  }

  const displayVotes = showAll ? votes : votes.slice(0, 3);
  const hasMore = votes.length > 3;

  return (
    <div className="mt-3 pt-3 border-t border-neutral-200">
      <p className="text-xs font-medium text-neutral-500 mb-2">Gestemd door:</p>
      <div className="flex flex-wrap gap-1.5">
        {displayVotes.map((vote) => (
          <span
            key={vote.userEmail}
            className="inline-flex items-center gap-1 px-2 py-0.5 bg-primary-50 text-primary-600 text-xs rounded-full"
            title={vote.userEmail}
          >
            <span className="w-4 h-4 rounded-full bg-primary-200 text-primary-600 flex items-center justify-center text-[10px] font-semibold">
              {vote.userDisplayName.charAt(0).toUpperCase()}
            </span>
            {vote.userDisplayName}
          </span>
        ))}
        {hasMore && !showAll && (
          <button
            onClick={() => setShowAll(true)}
            className="text-xs text-primary-600 hover:text-primary-400 font-medium"
          >
            +{votes.length - 3} meer
          </button>
        )}
      </div>
    </div>
  );
};

export default VoterList;
